export function getTotalOfPages(count: number, limit: number) {
  const total = Math.floor(count / limit)
  return count % limit
    ? total
    : count === 0
    ? total
    : total - 1
}
